export default "__VITE_ASSET__X$Cn3DHj__"